/* eslint-disable */
import { takeEvery, call, put } from "redux-saga/effects";
import { GET_FORMPOST, SET_FORMPOST } from "../actions";
import {
  apiUrl,
  masterheaderconfig,
  clientheaderconfig,
} from "../components/Helpers/Config";
import Axios from "axios";
export const watchGetFormPost = function* () {
  yield takeEvery(GET_FORMPOST, workerGetFormPost);
};

function* workerGetFormPost({ formPayload, postUrl, authType, method }) {
  try {
    const result = yield call(
      getFormPost,
      formPayload,
      postUrl,
      authType,
      method
    );
    var resultArr = [];
    resultArr.push(result.data);
    yield put({ type: SET_FORMPOST, value: resultArr });
  } catch(e) {
    console.log(e, postUrl + " post failed");
    let returnerror = [];
    returnerror.push(e?.response?.data||[]);
    yield put({ type: SET_FORMPOST, value: returnerror });
    
  }
}

function getFormPost(formPayload, postUrl, authType, method) {
    var headerConfig =
      authType === "client" ? clientheaderconfig : masterheaderconfig;
    if (method === "update") {
      return Axios.put(apiUrl + postUrl, formPayload, headerConfig);
    } else {
      return Axios.post(apiUrl + postUrl, formPayload, headerConfig);
    }
}
